import { useState } from "react";

import RoleSelector from "./RoleSelector";
import Login from "./Login";
import Register from "./Register";

import TownSelector from "./TownSelector";
import PropertyCategory from "./PropertyCategory";
import HouseTypes from "./housetypes";
import HouseList from "./houselist";
import HouseDetails from "./housedetails";

import LandlordDashboard from "./LandlordDashboard";
import "./styles.css";
import "./responsive.css";
function App() {

  const [role, setRole] =
    useState("");

  const [showRegister,
    setShowRegister] =
    useState(false);

  const [loggedIn,
    setLoggedIn] =
    useState(false);

  const [selectedTown,
    setSelectedTown] =
    useState("");

  const [selectedCategory,
    setSelectedCategory] =
    useState("");

  const [selectedType,
    setSelectedType] =
    useState("");

  const [selectedHouse,
    setSelectedHouse] =
    useState(null);

  // LANDLORD

 // LANDLORD (Login Temporarily Disabled)

if (role === "landlord") {

  return (
    <LandlordDashboard
      onLogout={() => {
        setRole("");
      }}
    />
  );

}

  // TENANT

  if (role === "tenant") {

    if (selectedHouse) {

      return (
        <HouseDetails
          house={selectedHouse}
          goBack={() =>
            setSelectedHouse(null)
          }
        />
      );

    }

    if (selectedType) {

      return (
        <HouseList
          selectedTown={selectedTown}
          selectedType={selectedType}
          selectedCategory={selectedCategory}
          setSelectedHouse={setSelectedHouse}
          goBack={() =>
            setSelectedType("")
          }
        />
      );

    }

    if (selectedCategory) {

      return (
        <HouseTypes
          selectedCategory={selectedCategory}
          setSelectedType={setSelectedType}
          goBack={() =>
            setSelectedCategory("")
          }
        />
      );

    }

    if (selectedTown) {

      return (
        <PropertyCategory
          setSelectedCategory={
            setSelectedCategory
          }
          goBack={() =>
            setSelectedTown("")
          }
        />
      );

    }

    return (
      <TownSelector
        setSelectedTown={
          setSelectedTown
        }
        goBack={() =>
          setRole("")
        }
      />
    );

  }

  return (
    <RoleSelector
      setRole={setRole}
    />
  );

}

export default App;